import React from "react";

import SampleIssuePill from "./SampleIssuePill";
import { buildIssueSampleRecord } from "./submissionIssueUtils";
import {
  formatSubmissionDateTime,
} from "./submissionTableUtils";
import SubmissionTypeLabel from "./SubmissionTypeLabel";

import "./SubmittedSubmissionIssueChildRow.css";

import { ReactComponent as DraftLine } from "../../../../assets/images/sample-submission/DraftLine.svg";

const renderCellText = (value) => {
  const text = value === null || value === undefined || value === "" ? "-" : String(value);
  return text;
};

export default function SubmittedSubmissionIssueChildRow({
  submission,
  issueSample,
  onIssueSampleClick,
  showExtendedColumns = false,
  showSubmissionType = false,
  showSampleIssue = false,
  hasExpandColumn = false,
  showActionsColumn = false,
}) {
  const record = buildIssueSampleRecord(issueSample, submission);

  const handleClick = () => {
    if (typeof onIssueSampleClick === "function") {
      onIssueSampleClick(submission, issueSample);
    }
  };

  const renderDataCell = (content, className = "") => (
    <td className={className.trim()} onClick={handleClick}>
      {content}
    </td>
  );

  const lastActionOnText = formatSubmissionDateTime(submission.last_action_on);

  return (
    <tr className="submitted-submission-issue-child-row" onClick={handleClick}>
      {hasExpandColumn && <td className="submitted-submission-issue-child-row__expand" aria-hidden />}
      <td className="submitted-submission-issue-child-row__status" onClick={handleClick}>
        <div className="submitted-submissions-status-content submitted-submissions-status-content--draft">
          <DraftLine className="submitted-submissions-status-draft-icon" aria-hidden width="15px" height="15px" />
          <span className="submitted-submission-issue-child-row__draft">Draft</span>
        </div>
      </td>
      {renderDataCell(
        <div title={issueSample.sample_id} className="submitted-submission-name">
          {renderCellText(issueSample.sample_id)}
        </div>,
      )}
      {renderDataCell(renderCellText(submission.po || "-"), "submitted-submissions-po-td")}
      {showSubmissionType && renderDataCell(
        <SubmissionTypeLabel submission={submission} />,
        "submitted-submissions-type-td",
      )}
      {showExtendedColumns && renderDataCell(
        renderCellText(lastActionOnText),
        "submitted-submissions-last-action-on-td submitted-submissions-last-action-on-td--static",
      )}
      {showExtendedColumns && renderDataCell(
        renderCellText(submission.last_action_by),
        "submitted-submissions-last-action-by-td",
      )}
      {/* {renderDataCell(
        submission.submit_date ? formatSubmissionDateTime(submission.submit_date) : "-",
        "submitted-submissions-submitted-on-td",
      )}
      {renderDataCell(
        renderCellText(submission.submitted_by),
        "submitted-submissions-submitted-by-td",
      )} */}
      {renderDataCell(
        "1",
        "submitted-submissions-table-samples-number-td",
      )}
      {showExtendedColumns && renderDataCell(
        renderCellText(issueSample.num_of_tests),
        "submitted-submissions-table-total-tests-td",
      )}
      {showSampleIssue && (
        <td className="submitted-submissions-sample-issue-td" onClick={handleClick}>
          <SampleIssuePill issueType={record.issue_type} showCreditsRefunded />
        </td>
      )}
      {showActionsColumn && <td className="submitted-submissions-table-actions-td" aria-hidden />}
    </tr>
  );
}
